module.exports = __webpack_public_path__ + "img/57.dd0af9a8.svg";